import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.scss";

import "react-datepicker/dist/react-datepicker.css";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import "react-tooltip/dist/react-tooltip.css";
import { AppWrapper } from "./layouts/appWrapper.jsx";

Bugsnag.start({
  apiKey: "0982d7d025fa672d34f200b223a042fc",
  plugins: [new BugsnagPluginReact()],
});

ReactDOM.createRoot(document.getElementById("root")).render(
  process.env.NODE_ENV === "production" ? (
    <AppWrapper />
  ) : (
    <React.StrictMode>
      <AppWrapper />
    </React.StrictMode>
  )
);
